import React from 'react';

import { COLUMN_WIDTHS } from '../constants';

import ColumnFilterSort from '../../components/tableServerSide/ColumnFilterSort';
import CatalogTypeTableCell from '../account/AccountDepartments/CatalogTypeTableCell';

import { escapeSpecialCharsInFilterInput } from '../util';

export const columnSortModifiersDepartments = {
  number: null,
  name: null,
  accountId: { disabled: true },
  accountName: { disabled: true },
  catalogTypes: { disabled: true },
  salesOrg: { disabled: true },
  defaultSort: {}
};

export const getColumnFilterModifiersDepartments = allAccounts => {
  return {
    number: { expression: '' },
    name: { expression: 'Like' },
    accountId: { value: input => allAccounts.find(account => account.number === input)?.id },
    accountName: { expression: 'Like' },
    catalogTypes: { colId: 'catalogTypeName', expression: 'Like', value: escapeSpecialCharsInFilterInput }
  };
};

export const getDepartmentColumns = ({
  departments,
  openAddCatalogTypeModal,
  openRemoveCatalogTypeModal,
  setSelectedDepartments,
  setSelectedCatalogType,
  accountsById
}) => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Sales Org' tableInstance={tableInstance} align='right' />,
      accessor: 'salesOrg',
      width: COLUMN_WIDTHS.XS,
      Cell: ({ row }) => accountsById[row.original.accountId]?.salesOrg || ''
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Sold-To Number' tableInstance={tableInstance} />,
      accessor: 'accountId',
      width: COLUMN_WIDTHS.XS,
      Cell: ({ value }) => accountsById[value]?.number || ''
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Sold-To Name' tableInstance={tableInstance} />,
      accessor: 'accountName',
      width: COLUMN_WIDTHS.MD,
      Cell: ({ row }) => accountsById[row.original.accountId]?.name || ''
    },
    {
      Header: tableInstance => (
        <ColumnFilterSort header='Department Number' tableInstance={tableInstance} align='right' />
      ),
      accessor: 'number',
      width: COLUMN_WIDTHS.XS
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Department Name' tableInstance={tableInstance} />,
      accessor: 'name',
      width: COLUMN_WIDTHS.MD,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => {
        return <span data-testid='departmentName'>{value}</span>;
      }
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog Type' tableInstance={tableInstance} />,
      id: 'catalogTypes',
      width: COLUMN_WIDTHS.XXL,
      accessor: department => department,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value: { id } }) => {
        return (
          <CatalogTypeTableCell
            department={departments.find(dep => dep.id === id)}
            openAddCatalogTypeModal={openAddCatalogTypeModal}
            openRemoveCatalogTypeModal={openRemoveCatalogTypeModal}
            setSelectedDepartments={setSelectedDepartments}
            setSelectedCatalogType={setSelectedCatalogType}
          />
        );
      }
    }
  ];
};
